import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const ExpenseViewodal = ({ show, handleClose, isEdit }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">
                        View Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Driver Name:</span>
                            <p>{isEdit?.driver_id || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Expense Type:</span>
                            <p>{isEdit?.type || '-'}</p>
                        </div>
                        <div className="col-md-12 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Expense Description:</span>
                            <p>{isEdit?.description || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Expense Amount:</span>
                            <p>{isEdit?.amount || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Expense Start Date:</span>
                            <p>{isEdit?.start || '-'}</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Expense End Date:</span>
                            <p>{isEdit?.end || '-'}</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* <ExpenseEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            /> */}
        </>
    );
};

export default ExpenseViewodal;